exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bgimage-copyright {\n  position: absolute;\n  bottom: 10px;\n  color: #ccc;\n  font-style: italic;\n}\n.bgimage-copyright a,\n.bgimage-copyright a:hover {\n  color: #ccc;\n  text-decoration: none;\n}\n@media (max-width: 600px) {\n.bgimage-copyright {\n    bottom: 70px;\n}\n}\n.search-spinner-button {\n  position: absolute;\n  bottom: 17px;\n  left: 46%;\n}\n@media (min-width: 960px) {\n.search-spinner-button {\n    bottom: 18px;\n    left: 48%;\n}\n}\n@media (min-width: 1264px) {\n.search-spinner-button {\n    bottom: 18px;\n    left: 48%;\n}\n}", ""]);

// exports
